// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"f909d16874c783e424c8","453":"27235b7e1d06c3d80c69","543":"80d531ec465ddef68466"}[chunkId] + ".js";
};